import { render, staticRenderFns } from "./PermissionTransactions.vue?vue&type=template&id=990b3140&scoped=true&"
import script from "./PermissionTransactions.vue?vue&type=script&lang=js&"
export * from "./PermissionTransactions.vue?vue&type=script&lang=js&"
import style0 from "./PermissionTransactions.vue?vue&type=style&index=0&id=990b3140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990b3140",
  null
  
)

export default component.exports